export const create_audio_view = () => ({
    init(){

    },

    async createAudio($event){
        const { isConfirmed } = await Swal.fire({
            title: 'Crear Audio',
            text: '¿Desea continuar con la creación del registro?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Crear',
            cancelButtonText: 'Cancelar'
        });

        if (!isConfirmed) return;

        const formData = new FormData($event.target);

        try {
            const { data } = await axios.post('/api/audios', formData);

            debugger;
            this.$dispatch('add-toast', {
                type: 'success',
                title: 'Audio creado',
                text: `Se ha creado el audio <strong>${data.name}</strong>`
            });

            console.log('data', data);
        } catch (error) {
            this.$dispatch('add-toast', {
                type: 'error',
                title: 'Fallo al crear audio',
                text: 'Unespected error. See console for more details.'
            });
            console.error('Error al crear audio', error);
            return;
        }
    }
});
